<table class="table-container">
  <thead>
    <tr>
      <th *ngFor="let header of content.headers">{{ header }}</th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let row of content.rows | paginate: { itemsPerPage: content.numberOfElements, currentPage: content.number + 1, totalItems: content.totalElements}"
      (click)="onRowClick(row.id)">
      <td *ngFor="let cell of row.cells" [class]="cell.cssClass">

        <ng-container *ngIf="cell?.type === 'button'">
          <i type="button" [class]="cell.value" (click)="executeCallback(cell, $event)"></i>
        </ng-container>

        <ng-container *ngIf="!cell?.type || cell.type === 'text'">
          <span [class]="cell.cssClass">{{ cell.value }}</span>
        </ng-container>

      </td>
    </tr>
  </tbody>
</table>
<div *ngIf='content.errorMessage?.length > 0' class="alert alert-warning">{{ content.errorMessage }}</div>
<div *ngIf="enablePagination" class="paginator">
  <pagination-controls (pageChange)="onPageChange($event)"></pagination-controls>
</div>